import store from '../store'

export function multiLangTextObject(value) {
  let languages = store.getters.languages
  let defaultLanguage = store.getters.defaultLanguage
  if (!languages || languages.length === 0 || !Array.isArray(languages)) {
    languages = ["de"]
  } 
  
  languages = languages.sort((a) => {
    if (a === defaultLanguage) {
      return -1
    } else {
      return 1
    }
  })

  if (!value || typeof value === 'string') {
    var ml = languages.reduce(function (map, lang) {
      map[lang.toLowerCase()] = ''
      return map;
    }, {});
    ml.lang = languages[0].toLowerCase()
    return ml
  }
  return value
}

export function getTextFromMultiLang(field, lang) {
  if (!field || typeof field === 'string') {
    return field || ''
  } else {
    return field[lang]
  }
}
